import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { NavLink } from 'react-router-dom'
import { propOr, F } from 'ramda'
import classNames from 'classnames'

import Carousel from '../carousel'
import { TARGET_TYPES } from '../../constants'
import FEATURED_TAB_COMPONENT_FRAGMENT from '../../../graphql/fragments/featured-tab-component.gql'
import Button from '../button'
import styles from './featured-tabs.css'

/*
* FeaturedTabComponent on logged out home page
*/

function FeaturedTabComponent({
  theme,
  isContentItemOnMyList,
  featuredTabsComponent
}) {
  const tabs = featuredTabsComponent?.featuredTabs || []
  const [selectedTab, setSelectedTab] = useState(tabs[0])

  if (!selectedTab) return null

  const ctaType = propOr('', 'type', selectedTab.cta)
  const ctaTarget = propOr('', 'target', selectedTab.cta)
  const ctaText = propOr('', 'text', selectedTab.cta)

  return (
    <div className={styles.contentFrame}>
      <div className={styles.contentWrapper}>
        {/* Tab Header */}
        <div className={styles.tabBar}>
          {tabs.map(tab => (
            <div
              key={tab.name}
              onClick={() => setSelectedTab(tab)}
              className={classNames(`${selectedTab.name === tab.name ? styles.active : ''}`, styles.tab)}
            >
              {tab.name}
            </div>
          ))}
        </div>

        {/* Selected Tab Content */}
        <div className={styles.tabContainer}>
          <div className={styles.tabContent}>
            {selectedTab.headerImageUri ? (
              <img
                src={selectedTab.headerImageUri}
                alt={selectedTab.header}
                className={styles.headerImage}
              />
            ) : (
              <div className={styles.header}>{selectedTab.header}</div>
            )}

            <div className={styles.description}>{selectedTab.description}</div>
          </div>

          {ctaTarget && (
            ctaType === TARGET_TYPES.EXTERNAL_URL ? (
              <a
                href={ctaTarget}
                className={styles.ctaFrame}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  text={ctaText}
                  className={styles.cta}
                  darkBGSecondary
                />
              </a>
            ) : (
              <NavLink
                to={ctaTarget}
                className={styles.ctaFrame}
              >
                <Button
                  text={ctaText}
                  className={styles.cta}
                  darkBGSecondary
                />
              </NavLink>
            )
          )}
        </div>

        {/* Selected Tab Carousel */}
        <Carousel
          theme={theme}
          key={selectedTab.componentCarousel.id}
          carousel={selectedTab.componentCarousel}
          isContentItemOnMyList={isContentItemOnMyList}
          inFeaturedTab
        />
      </div>
    </div>
  )
}

FeaturedTabComponent.propTypes = {
  theme: PropTypes.string.isRequired,
  featuredTabsComponent: propType(FEATURED_TAB_COMPONENT_FRAGMENT).isRequired,
  isContentItemOnMyList: PropTypes.func
}

FeaturedTabComponent.defaultProps = {
  isContentItemOnMyList: F
}

export default FeaturedTabComponent
